import React, { MouseEventHandler } from "react";
import statusValidationErrorsStyle from "./statusValidationErrorsStyle";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import _ from "lodash";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import { isLegalbirdError, LegalbirdError } from "../../../types/LegalbirdError";

type StatusValidationErrorsProps = {
  error: LegalbirdError;
  stage: string;
  closeDialog: MouseEventHandler<HTMLButtonElement>;
};
const StatusValidationErrors = ({ error, stage, closeDialog }: StatusValidationErrorsProps) => {
  if (!isLegalbirdError(error)) {
    return null;
  }

  return (
    <LegalbirdIoModal
      handleClose={closeDialog}
      open={!!error}
      title={!!error.errors ? "Fehlende Daten" : "Technischer Fehler"}
      submitButton={
        <Button variant={"contained"} onClick={closeDialog}>
          Ok
        </Button>
      }
      hideCancelButton={true}
    >
      <Grid container>
        {error.status === 422 ? (
          <>
            <Grid sx={statusValidationErrorsStyle.commonText} size={12}>
              Für den Übergang in Status "{stage}" fehlen folgende Daten:
            </Grid>
            {_.map(error.errors, (error, index) => (
              <Grid key={index} sx={statusValidationErrorsStyle.commonText} size={12}>
                - {error}
              </Grid>
            ))}
          </>
        ) : (
          <>
            <Grid sx={statusValidationErrorsStyle.commonText} size={12}>
              Leider ist ein technischer Fehler ist aufgetreten. Bitte merken Sie sich, in welcher Situation der Fehler
              aufgetreten ist und kontaktieren Sie die IT.
            </Grid>
            <Grid sx={statusValidationErrorsStyle.errorText} size={12}>
              Fehler: "{error.message}" [{error.status}].
            </Grid>
          </>
        )}
      </Grid>
    </LegalbirdIoModal>
  );
};

export default StatusValidationErrors;
